import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './DamSummary.module.css';
import BigStat from './BigStat.jsx';
import SmallStat from './SmallStat.jsx';
import { determineLevelAboveBelow, determineDischarge, determineStorage } from '../helpers/DamHelper.js';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';
import { faSluiceOpen, faSluiceFullyOpen, faSluiceClosed } from '@awesome.me/kit-2be97ecbd6/icons/kit/custom';
import { STATES_GATE_STATE_CLOSED, STATES_GATE_STATE_FULLY_OPEN, STATES_GATE_STATE_OPEN } from '../../../lambdas/common/const.js';
import Placeholder from './Placeholder.jsx';

function DamSummary({ dam, damMeta, error, title, link }) {
  const {t} = useTranslation();
  console.log("DamSummary", dam, damMeta, link);
  
  const damSiteMeta = damMeta?.site;
  const damSite = dam?.siteSummary?.find(site => site.id === damSiteMeta?.id);
  
  const storageStats = determineStorage(t, damSiteMeta, damSite?.lastValue);
  const { gateState, dischargeRate } = determineDischarge(t, damSiteMeta, damSite?.lastValue, damSite?.state);

  return (
    <div className={styles.DamSummaryContainer}>
      <div className={styles.DamSummaryHeader}>
        <h4>{title}</h4>
      </div>
      <div className={styles.DamSummaryContent}>
        <BigStat
          stat={storageStats?.percent ? (storageStats?.percent * 100).toFixed(2) : undefined}
          unit={'%'}
          secondStat={determineLevelAboveBelow(t, damSiteMeta, damSite?.lastValue)}
        />
        <div className={styles.DamSummaryDischarge}>
          <div className={styles.DamSummaryDimStat}>
          <Placeholder ready={gateState} className={styles.DamSummaryDimStatIcon}>
            {gateState === STATES_GATE_STATE_CLOSED && (<FontAwesomeIcon icon={faSluiceClosed} className={styles.DamSummaryDimStatIcon} />)}
            {gateState === STATES_GATE_STATE_OPEN && (<FontAwesomeIcon icon={faSluiceOpen} className={styles.DamSummaryDimStatIcon}/>)}
            {gateState === STATES_GATE_STATE_FULLY_OPEN && (<FontAwesomeIcon icon={faSluiceFullyOpen} className={styles.DamSummaryDimStatIcon} />)}
          </Placeholder>
          <div>
            <SmallStat
              stat={gateState ? t('dams.spillway_gates_state', {state: gateState?.toLowerCase()}) : undefined}
              secondStat={dischargeRate ? `Discharging ${dischargeRate} m³/s` : undefined}
              diminishedStat
            />
          </div>
          </div>
          <div className={"small text-muted"}>
            {t('disclaimers.tcc_eap')}
          </div>
        </div>
      </div>
      <div className={styles.DamSummaryAction}>
        {link && (
          <a href={link} className={clsx(styles.DamSummaryBtn, 'btn', 'btn-link')}>
            View Dam Details<FontAwesomeIcon icon={faArrowRight} className={styles.DamSummaryBtnIcon} />
          </a>
        )}
      </div>
    </div>
  );
};

DamSummary.propTypes = {
  dam: PropTypes.object,
  damMeta: PropTypes.object,
  error: PropTypes.bool,
  title: PropTypes.string.isRequired,
  link: PropTypes.string,
};

export default DamSummary;
